// extracted by mini-css-extract-plugin
export default {"listItem":"style_listItem__PPQzP","content":"style_content__CNr8U","date":"style_date__IjIMj"};